<script lang="ts">
	type TypingType = 'assistant' | 'user'

	type Props = {
		type: TypingType
	}

	let { type }: Props = $props()
</script>

<div class="typing-indicator-container {type}">
	<div class="typing-indicator-wrapper">
		<div class="typing-dot"></div>
		<div class="typing-dot"></div>
		<div class="typing-dot"></div>
	</div>
</div>

<style lang="postcss">
	.typing-indicator-container {
		@apply flex w-full mb-4 mt-4;
	}

	.typing-indicator-container.assistant {
		@apply justify-start pl-12;
	}

	.typing-indicator-container.user {
		@apply justify-end pr-12;
	}

	.typing-indicator-wrapper {
		@apply flex gap-1 items-center px-6 py-4 w-fit;
	}

	.typing-indicator-container.assistant .typing-indicator-wrapper {
		@apply bg-[rgba(0,73,128,0.06)] rounded-[24px_24px_24px_0px];
	}

	.typing-indicator-container.user .typing-indicator-wrapper {
		@apply bg-[rgba(20,213,134,0.2)] rounded-[24px_24px_0px_24px];
	}

	.typing-dot {
		@apply w-1.5 h-1.5 rounded-full;
		animation: typing 1.4s infinite ease-in-out both;
	}

	.typing-indicator-container.assistant .typing-dot {
		@apply bg-[#004980a3];
	}

	.typing-indicator-container.user .typing-dot {
		@apply bg-[#14d586e6];
	}

	.typing-dot:nth-child(1) {
		animation-delay: -0.32s;
	}

	.typing-dot:nth-child(2) {
		animation-delay: -0.16s;
	}

	@keyframes typing {
		0%,
		80%,
		100% {
			transform: scale(0);
		}
		40% {
			transform: scale(1);
		}
	}
</style>
